module.exports = __webpack_public_path__ + "img/engravingOnTheSide@2x.fc0f7ec.webp";